import React, {  createContext, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import jwtDecode from 'jwt-decode';
import * as ActionsAuth from '~/store/modules/auth/actions';
import { apiLucree, apiToken } from '~/services/api';




export const TokenContext = createContext([]);

export function TokenProvider(props) {
	const { children } = props;
	const { authv1 } = useSelector((state) => state.auth);
	const dispatch = useDispatch();
	const [loadingToken, setLoadingToken] = useState(true);

	async function authToken() {
		try {
			const responseApiToken = await apiToken.get('/');
			return responseApiToken.data.id_token;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de TOKEN não foram carregados. Por favor atualize a página'
			);
		}

		return null;
	}

	async function autenticacaoV1Token() {
		if(authv1.expires){
			
			const expiresIn10Min = authv1.expires * 1000 - Date.now() <= 10 * 60 * 1000;
			if(expiresIn10Min){
				try {
					const responseApiToken = await apiToken.get('/');
					if(responseApiToken.data.id_token){
						dispatch(ActionsAuth.successTokenV1({
							token: responseApiToken.data.id_token,
							expires: jwtDecode(responseApiToken.data.id_token).exp
						}));
					}else{
						
						dispatch(ActionsAuth.failedTokenV1("erro"));
					}
					return responseApiToken.data.id_token;
				} catch (error) {
					toast.error(
						'Os dados de autenticação de TOKEN não foram carregados. Por favor atualize a página'
					);
				}
			} else {
				return authv1.token;
			}
		}else{
			try {
				const responseApiToken = await apiToken.get('/');			
				if(responseApiToken.data.id_token){
					dispatch(ActionsAuth.successTokenV1({
						token: responseApiToken.data.id_token,
						expires: jwtDecode(responseApiToken.data.id_token).exp
					}));
				}else{
					dispatch(ActionsAuth.failedTokenV1("erro"));
				}
				return responseApiToken.data.id_token;
			} catch (error) {
				toast.error(
					'Os dados de autenticação de TOKEN não foram carregados. Por favor atualize a página'
				);
			}
		}

		return null;
	}

	async function callVerifyDoc(doc) {
		try {
			return await apiLucree.post(`authentication/api/verifica-documento/`, {
				documento: doc,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			setLoadingToken(false);
			return error.response;
		}
	}

	async function getCodeByType(doc, type) {
		try {
			return await apiLucree.post(`authentication/api/solicita-envio-codigo-totp/`, {
				documento: doc,
				metodo_envio_totp_code: type,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			toast.error('Ocorreu um erro. Tente novamente.')
			setLoadingToken(false);
			return error.response;
		}
	}

	async function callVerifyCode(doc, code) {
		try {
			return await apiLucree.post(`authentication/api/verifica-codigo-totp/`, {
				documento: doc,
				codigo_totp: code,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res) => {
				setLoadingToken(false);
				return res;
			});
		} catch (error) {
			toast.error('Ocorreu um erro. Tente novamente.')
			setLoadingToken(false);
			return error.response;
		}
	}



	return (
		<TokenContext.Provider
			value={{
				authToken,
				autenticacaoV1Token,
				loadingToken,
				setLoadingToken,
				callVerifyDoc,
				getCodeByType,
				callVerifyCode,
			}}>
			{children}
		</TokenContext.Provider>
	);
}
